(function () {
  "use strict";

  ManageCustomFieldsCtrl.$inject = ['$scope', 'customFieldsResource', 'mtypes', '$window', 'resolveData', 'accountCustomFields', 'Validation', '$rootScope', '$location', 'untitledFieldService', 'authView', 'trainerPrivilege'];
  angular
    .module('trainerWebApp.controllers')
    .controller('ManageCustomFieldsCtrl', ManageCustomFieldsCtrl);

  function ManageCustomFieldsCtrl($scope, customFieldsResource, mtypes, $window, resolveData, accountCustomFields,
                                  Validation, $rootScope, $location, untitledFieldService, authView, trainerPrivilege) {

    var fieldVisbility = mtypes.userCustomFieldVisbility;
    var fieldRequired = mtypes.userCustomFieldRequiredState;
    var userRole = trainerPrivilege.roles();

    var amountOfCustomFieldsAllowed;
    var initialCustomFields = [];
    var removedFieldDisplayOrders = {};
    var nextLocation;

    if (!userRole.canEditCustomFields)
      $location.path('/TMS/ManageUsers');

    $scope.formDirty = false;
    $scope.customFieldAdded = false;

    Validation.addValidation(validateNavigation);

    function validateNavigation() {
      if (!$scope.formDirty) return true;
      nextLocation = $rootScope.newLocation.next;
      $scope.$broadcast('showUnsavedChanges');
      return false;
    }

    $scope.$on('unsavedChangesLeave', function () {
      Validation.removeValidation(validateNavigation);
      setTimeout(function () {
        $location.path(nextLocation.path).search(nextLocation.search);
        $rootScope.$apply();
      }, 50)
    });

    $scope.$on('$destroy', function () {
      Validation.removeValidation(validateNavigation);
    });

    $scope.addCustomField = function () {
      checkCustomFieldLimit();
      if ($scope.allFieldsUsed)
        return;

      toggleEditorEnabled();
      setUntitledFields();

      $scope.customFields.push({
        displayOrder: -1,
        id: null,
        name: "",
        requiredState: fieldRequired.optional,
        visibilityMode: fieldVisbility.accountOnly,
        editorEnabled: true
      });
      reIndexFields();
      checkCustomFieldLimit();
      $scope.formDirty = true;
    };

    $scope.removeCustomField = function (item, index) {
      if (!item.id) // removing a new field is a noop
        removedFieldDisplayOrders[index] = true;

      $scope.customFields.splice(index, 1);
      reIndexFields();
      checkCustomFieldLimit();
      $scope.formDirty = true;
    };

    $scope.save = function () {
      reIndexFields();
      toggleEditorEnabled();
      setUntitledFields();

      var fieldsToSave = _.map($scope.customFields, function (item) {
        item.visibilityMode = item.publicCoursePageVisible ? fieldVisbility.publicCoursePage : fieldVisbility.accountOnly;
        item.requiredState = item.required ? fieldRequired.required : fieldRequired.optional;

        return _.omit(item, 'editorEnabled', 'publicCoursePageVisible', 'required', 'id');
      });
      var dto = {
        customFields: fieldsToSave,
        removedFieldDisplayOrders: _.keys(removedFieldDisplayOrders)
      };

      customFieldsResource.save(dto, function (result) {
        initialCustomFields = result.customFields;
        reset();
        accountCustomFields.setCustomFields(result.customFields);
        $scope.customFieldAdded = true;
      });
    };

    $scope.enableEditor = function (event, customField) {
      if (customField)
        event.stopPropagation();
      toggleEditorEnabled(customField);
      setUntitledFields();
      setPublicVisibility();
    };

    $scope.editorKeyDown = function (event, customField) {
      event.which = event.which || event.keyCode;
      if (event.which !== 13) return;

      toggleEditorEnabled();
      setUntitledFields();

      customField.publicCoursePageVisible = customField.publicCoursePageVisible === undefined ? false : customField.publicCoursePageVisible;
    };

    function toggleEditorEnabled(customField) {
      customField = customField || {};
      _.each($scope.customFields, function (field) {
        field.editorEnabled = field == customField;
        field.publicCoursePageVisible = field.publicCoursePageVisible === undefined ? false : field.publicCoursePageVisible;
      });
    }

    function setPublicVisibility() {
      var fields = $scope.customFields;
      for (var i = 0, c = fields.length; i < c; i++) {
        fields[i].publicCoursePageVisible = fields[i].publicCoursePageVisible === undefined ? false : fields[i].publicCoursePageVisible;
      }
    }

    var setUntitledFields = this.setUntitledFields = function () {
      untitledFieldService.nameEmptyFields({
        collection: $scope.customFields,
        nameProp: 'name',
        ignoreIf: 'editorEnabled'
      });
    };

    var scopeWatcher;

    var reset = $scope.reset = function () {
      if (scopeWatcher)
        scopeWatcher();

      $scope.formDirty = false;
      removedFieldDisplayOrders = {};

      var customFields = [];
      _.each(initialCustomFields, function (field) {
        field.publicCoursePageVisible = field.visibilityMode == fieldVisbility.publicCoursePage;
        field.required = field.requiredState == fieldRequired.required;
        customFields.push(_.clone(field));
      });
      $scope.customFields = customFields;
      checkCustomFieldLimit();

      scopeWatcher = $scope.$watch('customFields', checkDirty, true);
    };

    function setup() {
      $window.document.title = "Custom Fields | Mindflash Training Management System";

      amountOfCustomFieldsAllowed = resolveData.amountOfCustomFieldsAllowed;
      initialCustomFields = resolveData.customFields;

      $scope.showAdditionalFieldsText = authView.isTrial() || amountOfCustomFieldsAllowed < 10;
      resolveData = null;

      reset();
    }

    function reIndexFields() {
      var fields = $scope.customFields;
      for (var i = 0, c = fields.length; i < c; i++) {
        fields[i].displayOrder = i;
      }
    }

    function checkCustomFieldLimit() {
      $scope.allFieldsUsed = $scope.customFields.length == amountOfCustomFieldsAllowed;
    }

    var checkDirty = this.checkDirty = function () {
      var fields = $scope.customFields;
      if (initialCustomFields.length != fields.length)
        return $scope.formDirty = true;

      for (var i = 0, c = fields.length; i < c; i++) {
        if (fieldsAreDifferent(fields[i], initialCustomFields[i]))
          return $scope.formDirty = true;
      }

      $scope.formDirty = false;
    };

    $scope.togglePublicVisibility = function (customField) {
      customField.publicCoursePageVisible = !customField.publicCoursePageVisible;
    };

    function fieldsAreDifferent(field1, field2) {
      if (!field1 || !field2) return true;

      var keys = ['displayOrder', 'name', 'required', 'publicCoursePageVisible'];
      for (var i = 0, c = keys.length; i < c; i++) {
        if (field1[keys[i]] != field2[keys[i]])
          return true;
      }

      return false;
    }

    setup();
  }

})();
